import React, { useState,useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Box,
  Badge,
  useTheme
} from '@mui/material';
import {
  AccountCircle,
  ArrowDropDown,
  Brightness4,
  Brightness7,
  Notifications
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import eventBus from './Eventbus';


const TopBar = ({ activeAccount, toggleTheme }) => {
  
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const [isCollapse, setIsCollapse] = useState(false);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/'
  };
  useEffect(() => {
    const handleSidebarToggle = (event) => {
        setIsCollapse(event.detail);
    };

    eventBus.addEventListener("sidebarToggle", handleSidebarToggle);

    return () => {
        eventBus.removeEventListener("sidebarToggle", handleSidebarToggle);
    };
}, []);
  const drawerWidthExpanded = 260;
  const drawerWidthCollapsed = 72;
  return (
    <AppBar
      position="fixed"
      sx={{
        width: `calc(100% - ${drawerWidthExpanded}px)`,
        ml: `${drawerWidthExpanded}px`,
        background: `linear-gradient(180deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
        color: theme.palette.text.primary,
        boxShadow: 'none',
        borderBottom: `1px solid ${theme.palette.divider}`,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        ...(isCollapse && {
          width: `calc(100% - ${drawerWidthCollapsed}px)`,
          ml: `${drawerWidthCollapsed}px`,
          transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }),
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between', px: 3 }}>
        {/* Left Section - Branding */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            background: `linear-gradient(45deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: '-0.5px',
          }}
        >
          {isCollapse &&(
            "Telegram Poster"
          )}
        </Typography>

        {/* Right Section - Theme Toggle, Notifications & Profile */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          {/* Theme Toggle Button */}
          <IconButton
            onClick={toggleTheme}
            color="inherit"
            sx={{
              borderRadius: '8px',
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
              },
            }}
          >
            {theme.palette.mode === 'dark' ? (
              <Brightness7 sx={{ color: theme.palette.warning.main }} />
            ) : (
              <Brightness4 sx={{ color: theme.palette.text.secondary }} />
            )}
          </IconButton>

          {/* Notifications */}
          {/* <IconButton
            color="inherit"
            sx={{
              borderRadius: '8px',
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
              },
            }}
          >
            <Badge badgeContent={3} color="error">
              <Notifications sx={{ color: theme.palette.text.secondary }} />
            </Badge>
          </IconButton> */}

          {/* User Information */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
                borderRadius: '8px',
              },
              p: 1,
            }}
            onClick={handleMenuOpen}
          >
            <Avatar
              sx={{
                width: 32,
                height: 32,
                bgcolor: theme.palette.primary.main,
                fontSize: 14,
              }}
            >
              {activeAccount?.username
                ? activeAccount.username.charAt(0).toUpperCase() +
                  activeAccount.username.charAt(1).toUpperCase()
                : 'G'}
            </Avatar>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <Typography
                variant="body2"
                sx={{ color: theme.palette.text.primary, fontWeight: 500 }}
              >
                {activeAccount?.username || 'Guest'}
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: theme.palette.text.secondary }}
              >
                {activeAccount.role}
              </Typography>
            </Box>
            <IconButton
              size="small"
              sx={{
                color: theme.palette.text.secondary,
                '&:hover': {
                  backgroundColor: 'transparent',
                },
              }}
            >
              <ArrowDropDown />
            </IconButton>
          </Box>
        </Box>
      </Toolbar>

      {/* Profile Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 200,
            borderRadius: '8px',
            boxShadow: theme.shadows[3],
            '& .MuiMenuItem-root': {
              fontSize: '0.875rem',
              py: 1.5,
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
              },
            },
          },
        }}
      >
        {/* <MenuItem onClick={handleClose}>Profile</MenuItem>
        <MenuItem onClick={handleClose}>Settings</MenuItem> */}
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </AppBar>
  );
};

export default TopBar;